import { AnyAction } from 'redux';
import { ACTIONS, TASK_ACTIONS } from '../actions/actions';
import produce from 'immer';
import { Task } from '../../types';

const initialState: {
  tasks: { [id: string]: Task };
  scheduledTasks: { [id: string]: Task };
  isLoading: boolean;
  parentTasks: { [id: string]: string[] };
  clientTasks: { [id: string]: string[] };
  scheduledTaskData?: any;
} = {
  tasks: {},
  scheduledTasks: {},
  isLoading: false,
  parentTasks: {},
  clientTasks: {},
  scheduledTaskData: undefined,
};

function taskReducer(state = initialState, action: AnyAction) {
  switch (action.type) {
    case ACTIONS.IS_LOADING: {
      return produce(state, (draftState) => {
        draftState.isLoading = action.payload;
      });
    }

    case TASK_ACTIONS.GET_TASKS: {
      return produce(state, (draftState) => {
        action.payload.forEach((task: Task) => {
          draftState.tasks[task.id] = task;
        });
      });
    }
    case TASK_ACTIONS.GET_TASKS_BY_ID: {
      return produce(state, (draftState) => {
        const task: Task = action.payload;
        draftState.tasks[task.id] = task;
      });
    }
    case TASK_ACTIONS.UPDATE_TASK: {
      return produce(state, (draftState) => {
        const task: Task = action.payload;
        draftState.tasks[task.id] = task;
      });
    }
    case TASK_ACTIONS.UPDATE_SCHEDULED_TASK: {
      return produce(state, (draftState) => {
        const task = action.payload;
        if (task.Task) {
          task.TaskName = task.Task.Name;
          draftState.tasks[task.Task.id] = task.Task;
          delete task.Task;
        } else if (draftState.tasks[task.TaskId]) {
          task.TaskName = draftState.tasks[task.TaskId].Name;
        }
        draftState.scheduledTasks[task.id] = task;
      });
    }
    case TASK_ACTIONS.GET_SCHEDULED_TASK: {
      const { parentId, data } = action.payload;
      return produce(state, (draftState) => {
        data.forEach((task: Task) => {
          if (task.Task) {
            task.TaskName = task.Task.Name;
            draftState.tasks[task.Task.id] = task.Task;
            delete task.Task;
          } else if (draftState.tasks[task.TaskId]) {
            task.TaskName = draftState.tasks[task.TaskId].Name;
          }
          draftState.scheduledTasks[task.id] = task;

          // if (draftState.clientTasks[task.ClientId]) {
          //   if (!draftState.clientTasks[task.ClientId].includes(task.id))
          //     draftState.clientTasks[task.ClientId].push(task.id);
          // } else {
          //   draftState.clientTasks[task.ClientId] = [task.id];
          // }
        });
        draftState.parentTasks[parentId] = data.map((elem: Task) => elem.id);
      });
    }
    case TASK_ACTIONS.SCHEDULED_TASKS_BY_CLIENT_ID: {
      return produce(state, (draftState) => {
        const { tasks, clientId } = action.payload;
        const taskIds = [];
        tasks.forEach((task: Task) => {
          if (task.Task) {
            task.TaskName = task.Task.Name;
            draftState.tasks[task.Task.id] = task.Task;
            delete task.Task;
          } else if (draftState.tasks[task.TaskId]) {
            task.TaskName = draftState.tasks[task.TaskId].Name;
          }
          draftState.scheduledTasks[task.id] = task;

          taskIds.push(task.id);

          if (draftState.parentTasks[task.TaskId]) {
            if (!draftState.parentTasks[task.TaskId].includes(task.id))
              draftState.parentTasks[task.TaskId].push(task.id);
          } else {
            draftState.parentTasks[task.TaskId] = [task.id];
          }
        });
        draftState.clientTasks[clientId] = taskIds;
      });
    }
    case TASK_ACTIONS.CREATE_SCHEDULED_TASK: {
      return produce(state, (draftState) => {
        draftState.scheduledTaskData = undefined;
        const task = action.payload;
        if (task.Task) {
          task.TaskName = task.Task.Name;
          draftState.tasks[task.Task.id] = task.Task;
          delete task.Task;
        } else if (draftState.tasks[task.TaskId]) {
          task.TaskName = draftState.tasks[task.TaskId].Name;
        }
        draftState.scheduledTasks[task.id] = task;
      });
    }
    case TASK_ACTIONS.CREATE_SCHEDULED_TASK_DATA: {
      return produce(state, (draftState) => {
        draftState.scheduledTaskData = action.payload;
      });
    }
    default:
      return state;
  }
}

export default taskReducer;
